import React, { Component, Fragment } from 'react';
import Form from 'react-bootstrap/Form';

import './CadeInput.css';

class CadeInputRaterComment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            whoFor: this.props.whoFor,
            comment: this.props.comment
        }
    }

    commentChangeHandler = (e) => {
        this.props.commentChangeHandler(this.state.whoFor, e.target.value);
    }

    render() {
        return (

            <Fragment>
                    <Form>
                       
                        <h4 className="cadeInput_sectionHeading">Optional Comment</h4>
                        <Form.Group controlId="cgCommentsG">
                        <Form.Control id="cgComments" as="textarea" rows="8" defaultValue={this.state.comment} onChange={this.commentChangeHandler}/>
                        </Form.Group>

                    </Form>
            </Fragment>

        )
    }
}

export default CadeInputRaterComment;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeInputRaterComment.js